import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import rightIcon from '@Images/icons/icon-right-white.png';
import plusIcon from '@Images/icons/icon-plus-white.png';
import plusIconBlue from '@Images/icons/icon-plus-blue.png';
import H3Image from '@Uilib/h3Image';
import H3Text from '../h3Text';
import './style.scss';

export const defaultButtonTypes = {
  TRANSPARENT_BORDER: 'button-transparent-border',
  ORANGE_SOLID: 'button-orange-solid',
  BLUE_ROUNDED: 'blue-rounded-solid',
  BLUE_ROUNDED_RELATIVE: 'blue-rounded-relative',
  WHITE_ROUNDED_RELATIVE: 'white-rounded-relative',
  BLUE_BORDERED: 'blue-rounded-bordered',
  GRAY_ROUNDED: 'gray-rounded-solid',
};

const H3Button = ({
  buttonType, disabled, isLoading, text, onClick, style, icon, iconClassName, customClass, id
}) => (
  <button
    id = {id}
    style={style}
    className={`button-default ${customClass} ${buttonType} ${disabled ? 'button-wrapper-disabled' : ''}`}
    onClick={() => (!disabled ? onClick() : {})}
    disabled={disabled}
  >
    {buttonType === 'white-rounded-relative' && !isLoading && <H3Image src={plusIconBlue} className="button-plus-icon" alt="continue" /> }
    {buttonType === 'blue-rounded-relative' && !isLoading && <H3Image src={plusIcon} className="button-plus-icon" alt="continue" /> }
    <H3Text
      className="button-wrapper__text"
      text={isLoading === true ? <LoadingOutlined style={{ fontSize: '20px', marginTop: '-5px', color: 'white' }} /> : text}
    />
    {icon === true && !isLoading && <H3Image src={rightIcon} className={`h3-button-icon ${iconClassName}`} alt="continue" /> }
  </button>
);

H3Button.propTypes = {
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  text: PropTypes.string,
  icon: PropTypes.any,
  buttonType: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.any,
  iconClassName: PropTypes.any,
};
export default H3Button;
